import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
@Component({
  selector: 'app-tournament-editable-page',
  templateUrl: './tournament-editable-page.component.html',
  styleUrls: ['./tournament-editable-page.component.scss']
})
export class TournamentEditablePageComponent implements OnInit {
  public isLoading: boolean = false;
  tournamentFormGeneral: FormGroup;
  tournamentFormDescription: FormGroup;
  activeTab: string = 'generalSettings';

  public panes: any[] = [];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.translate.get(['PANES.GENERAL_SETTINGS', 'PANES.CATEGORY', 'PANES.PAYMENT']).subscribe(translations => {
      this.panes = [
        { name: translations['PANES.GENERAL_SETTINGS'], content: 'generalSettings' },
        { name: translations['PANES.CATEGORY'], content: 'category' },
        { name: translations['PANES.PAYMENT'], content: 'payment' }
      ];
    });
  }

  navigateTo(tab: string) {
    console.log('tab', tab);
    this.activeTab = tab;
  }

  standingCreation() {
    const tournamentID = this.route.snapshot.params['id'];
    this.router.navigate([`tournaments/standingCreation/${tournamentID}`]);
  }
}
